import { useCallback, useEffect, useRef, useState } from 'react';

const COPIED_FOR_MS = 1600;

type UseCopyToClipboardResult = {
  isCopied: boolean;
  copy: (text: string) => Promise<void>;
};

/** Copies text and reports `isCopied` for 1.6 s, as the design's Copy / Copied label does. */
export function useCopyToClipboard(): UseCopyToClipboardResult {
  const [isCopied, setIsCopied] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const copy = useCallback(async (text: string) => {
    await navigator.clipboard.writeText(text);
    setIsCopied(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setIsCopied(false), COPIED_FOR_MS);
  }, []);

  return { isCopied, copy };
}
